























































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import FileUpload from '@/components/FileUpload/index.vue'

@Component({
  name: 'ProductionIosView',
  components: {
    FileUpload
  }
})
export default class extends mixins(DisplayMixin) {
  params = {
    type: '',
    channel: '',
    bundleId: '',
    packageName: '',
    appName: '',
    icon: '',
    appSize: '',
    appVersion: '',
    updateDate: '',
    appFilePath: '',
    descFilePath: '',
    status: '',
    newFunction: ''
  }
  typeList = [
    {
      'id': 1,
      'name': '海外助手'
    },
    {
      'id': 2,
      'name': 'pc 正版'
    },
    {
      'id': 3,
      'name': '国际版'
    }
  ]
  channelList = [
    {
      'id': 1,
      'name': '广告'
    },
    {
      'id': 2,
      'name': '兔兔官网'
    },
    {
      'id': 3,
      'name': '移动端'
    }
  ]

  handeSubmit() {}
}
